import React from 'react'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const MetaracismQuote = ({ content }) => {
    const renderOptionalHeader = () => {
        if (content?.title) {
            return (
                <div className="container">
                    <div className="title-wrapper">
                        <div className="title-stroke">
                            <h2>{content.title}</h2>
                        </div>
                    </div>
                </div>
            )
        }
    }

    if (!content) {
        return null
    }

    return (
        <div className="container">
            { renderOptionalHeader() }
            <div className="content-band metaracism-quote">
                <div className="quote">
                    <MarkdownWrapper content={content.content} />
                </div>
            </div>
        </div>
    )
}

export default MetaracismQuote
